import SubscriberCtrl from './controllers/index';
import SubscriberShowCtrl from './controllers/show';
import SubscriberImportCtrl from './controllers/import';
import SubscriberImportReportCtrl from "./controllers/importReport";
import subscriberGrid from './directives/subscriberGrid';
import subscriberSelectCreate from './directives/subscriberSelectCreate';
import subscriberSelectCreateByPhoneNumber from "./directives/subscriberSelectCreateByPhoneNumber";
import addSuppression from './directives/addSuppression';
import subscriberInformation from "./directives/subscriber-information";
import subscriberCustomData from "./directives/subscriber-custom-data";
import subscriberActivity from "./directives/subscriber-activity";
import reportCounter from "./directives/reportCounter";
import suppressionEntry from "./directives/suppression-entry";
import addToTag from "./directives/addToTag";
import preferenceSelect from "./directives/preference-select";
import Subscriber from './subscriber.repository';
import routing from './subscriber.routes';
import uirouter from 'angular-ui-router';

export default angular.module('app.subscriber', [uirouter])
    .config(routing)
    .controller('SubscriberCtrl', SubscriberCtrl)
    .controller('SubscriberShowCtrl', SubscriberShowCtrl)
    .controller('SubscriberImportCtrl', SubscriberImportCtrl)
    .controller('SubscriberImportReportCtrl', SubscriberImportReportCtrl)
    .directive('subscriberGrid', () => new subscriberGrid)
    .directive('addSuppression', () => new addSuppression)
    .directive('subscriberSelectCreate', () => new subscriberSelectCreate)
    .directive('subscriberSelectCreateByPhoneNumber', () => new subscriberSelectCreateByPhoneNumber)
    .directive('subscriberInformation', () => new subscriberInformation)
    .directive('subscriberCustomData', () => new subscriberCustomData)
    .directive('subscriberActivity', () => new subscriberActivity)
    .directive('reportCounter', () => new reportCounter)
    .directive('suppressionEntry', () => new suppressionEntry)
    .directive('addToTag', () => new addToTag)
    .directive('preferenceSelect', () => new preferenceSelect)
    .service('Subscriber', Subscriber)
    .name;
